import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const white = ui.white[500];
const navyBlue = ui.core[700];

export const highlightBackgroundColor = navyBlue;

export const highlightTextColor = white;

export const toastCss = {
  margin: "100px 20px 0 20px",
};
